export default {
  category: ["Leisure", "Incentive"],
  type: ["Prospect", "Client"],
};
